import { FaFile as FileIcon } from "react-icons/fa6";
import { BsFileEarmarkPdfFill as PdfIcon } from "react-icons/bs";
import { BsFiletypeMp4 as VideoIcon } from "react-icons/bs";
import { BsFiletypePptx as PptxIcon } from "react-icons/bs";
import { BsFiletypePpt as PptIcon } from "react-icons/bs";

const PRESENTATION_ICONS = {
  pptx: PptxIcon,
  mp4: VideoIcon,
  pdf: PdfIcon,
  ppt: PptIcon,
};

export const getPresentationIcon = (fileExt: string) => {
  return PRESENTATION_ICONS[fileExt] || FileIcon;
};
